import { TopolTextBlock } from "@/schemas/template/blocks/textBlockSchema";
import calcWidth from "./helpers";
import { v4 as uuidv4 } from "uuid";
import { i18n } from "../../init/i18n-setup";
import { mergeDeep } from "@/utils/mergeDeep";
import {
  TextAttributesSchema,
  TopolCustomBlockData,
  TopolCustomBlockMixContentWithKey,
} from "@/schemas/contentBlock/contentBlockScheme";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number },
    customBlockData?: TopolCustomBlockData | TopolCustomBlockMixContentWithKey
  ): TopolTextBlock {
    const attributes: TopolTextBlock["attributes"] = {
      align: "left",
      // "font-size": "11px",
      padding: state.mjml.attributes["mj-text"]["padding"]
        ? state.mjml.attributes["mj-text"]["padding"]
        : "15px",
      "line-height": state.mjml.attributes["mj-text"]["line-height"]
        ? state.mjml.attributes["mj-text"]["line-height"]
        : 1.5,
      color: state.mjml.attributes["mj-text"]["color"],
      containerWidth: calcWidth(
        state.mjml.children[0].attributes["containerWidth"],
        state.mjml.children[0].children[props.sectionIndex].children[
          props.columnIndex
        ].attributes["width"]
      ),
    };

    if (customBlockData && customBlockData.attributes) {
      let attributesToMerge: any = {};
      const textAttributes = TextAttributesSchema.safeParse(
        customBlockData.attributes
      );
      if (textAttributes.success) {
        attributesToMerge = textAttributes.data;
      } else {
        const attributesObject = JSON.parse(
          JSON.stringify(customBlockData.attributes)
        );
        textAttributes.error.issues.map((issue) => {
          delete attributesObject[issue.path[0]];
        });
        const newRes = TextAttributesSchema.safeParse(attributesObject);
        attributesToMerge = newRes.success ? newRes.data : {};
      }
      Object.keys(attributesToMerge).map((key) => {
        if (typeof attributesToMerge[key] === "object") {
          attributesToMerge[key] = attributesToMerge[key].value;
        }
      });
      mergeDeep(attributes, attributesToMerge);
    }

    return {
      uid: uuidv4(),
      tagName: "mj-text",
      content: customBlockData?.content
        ? customBlockData.content
        : i18n.global.t("layout.default_text"),
      attributes: attributes,
      customKey: customBlockData?.key ? customBlockData.key : null,
    };
  },
};
